module.exports = __webpack_public_path__ + "static/media/Nochnoe_nebo.29565afd.png";